<template lang="pug">
    v-card.page-card
        v-card-text
            v-form(v-model="formValid" ref="forgotemailform")
                //- v-alert.mb-6(dense outlined type="error") 
                //- v-alert.text-left(v-if="alertText != ''" outlined dense  type="error") {{alertText}}
                Alert
                .alert-text.mb-6 {{$t('Auth.__ForgotPasswordHint')}}
                v-text-field.page-input-field(v-model="email" solo dense outlined :rules="[rules.required, rules.email]" :placeholder="$t('Auth.__EnterEmail')" )
                v-btn.page-btn.mb-4(block rounded color="primary" @click="resetPassword") {{$t('Auth.__SendResetLink')}}
                .text.mb-10
                    router-link(:to="'/'+$i18n.locale+'/login'") {{$t('Auth.__BackToLogin')}}
                        

</template>

<script>
import * as textfieldUtils from "@/utils/textfield.js"

export default {
  data: () => ({
    formValid: false,
    email: "",
    description: "",
    alertText: "",
    rules: textfieldUtils.rules
  }),
  methods: {
    resetPassword() {
      this.alertText = ""
      this.$refs.forgotemailform.validate()
      if (this.formValid) {
        this.$store.dispatch("global/startLoading")
        this.$store
          .dispatch("auth/forgetPassword", { email: this.email })
          .then(
            function(response) {
              this.$store.dispatch("global/showAlert", {
                type: "success",
                message: this.$t("Messages.__ResetLinkSentHint")
              })
              this.$store.dispatch("global/stopLoading")
            }.bind(this)
          )
          .catch(
            function(error) {
              this.$store.dispatch("global/showAlert", {
                type: "error",
                message: error.message
              })
              this.$store.dispatch("global/stopLoading")
            }.bind(this)
          )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/login.scss";
</style>
